import { createActions } from 'reduxsauce';
import { removeSelectedItem } from '@iso/lib/helpers/CRUD';

export const { Types: types, Creators: actions } = createActions({
    requestDeleteProduct: ['id'],
    deleteProductSucceeded: ['id'],
    deleteProductFailed: ['error'],
});

export default {
    [types.REQUEST_DELETE_PRODUCT]: (state, { id }) => ({
        ...state,
        delete: {
            ...state.delete,
            id,
            loading: true,
            error: null,
        },
    }),
    [types.DELETE_PRODUCT_SUCCEEDED]: (state, { id }) => ({
        ...state,
        data: removeSelectedItem(state.data, id),
        delete: {
            ...state.delete,
            id: null,
            loading: false,
        },
    }),
    [types.DELETE_PRODUCT_FAILED]: (state, { error }) => ({
        ...state,
        delete: {
            ...state.delete,
            id: null,
            loading: false,
            error,
        },
    }),
};
